import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  ButtonGroup,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
const classNames = require("classnames");
import WelcomeCompNew from "./WelcomeCompNew";
import UpcomingAppointmentsNew from "./UpcommingAppointmentNew";
import NewAppointmentsNew from "./NewAppointment";
import DiscoverRequestIcon from "../../assets/images/icons/u_users-alt.png";
import ClientRequests from "./ClientRequests";
import CompletedSessions from "./CompletedSessions";
import { Ethinicity } from "src/models/Ethnicity";
import { FriendRequest } from "src/models/FriendRequest";
import { TherapistService } from "src/services/TherapistService";
import { ClientService } from "src/services/ClientService";
import { Appointment } from "src/models/Appointment";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { NotificationEvent, NotificationModel, NotificationVarient } from "src/models/Notification";
import UserContext from "src/context/UserContext";
import { NotificationService } from "src/services/NotificationService";
import { sendNotificationSocketData } from "src/models/sendNotificationCallSocketData";
import { SocketContext } from "src/context/ScoketContext";
import TherapistQuickChat from "./TherapistQuickChat";
import { CommonService } from "src/services/CommonService";
import OtpInput from "react-otp-input";
import UpComingGroupCall from "./UpComingGroupCall";
import ShowTherapistScore from "./ShowTherapistScore";
import ShowOngoingCalls from "./common/ShowOngoingCalls";
import axios from "axios";
import { Util } from "src/Util";
import Select from 'react-select';
import diagnosisOptions from 'src/pages/Chat/DiagnosisNote/Dataset/options';
import SchedulingCalendar from 'src/pages/Chat/vonage/vonage-express/components/EndCall/SchedulingCalendar';

const TherapistDashboardNew: React.FC = () => {
  const history = useHistory();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tabNo, setTabNo] = useState<string>("1");
  const [gender, setGender] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [selectedEthnicity, setSelectedEthnicity] = useState("");
  const [ethnicityList, setEthnicityList] = useState<Ethinicity[]>([]);
  const [matchedClients, setMatchedClients] = useState([] as FriendRequest[]);
  const [upcomingAppointments, setupcomingAppointments] = useState([] as Appointment[]);
  const [skip, setSkip] = useState(1);
  const [therapistAppointmentStats, setTherapistAppointmentStats] = useState();
  const [allTreatmentSessionStats, setAllTreatmentSessionStats] = useState([] as any[]);
  const [user, setUser] = useContext(UserContext);
  const socket = useContext(SocketContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isOpenPinNumberModal, setIsOpenPinNumberModal] = useState<boolean>(false);
  const [therapistEarningsStats, setTherapistEarningsStats] = useState<any>();
  const [pinNumber, setPinNumber] = useState("");
  const [invalidOtp, setInvalidOtp] = useState("");
  const [therapistTotalEarningsStats, setTherapistTotalEarningsStats] = useState<boolean>();
  const [newAppointments, setNewAppointments] = useState([] as Appointment[]);
  const [upCommingGroupCalls, setUpCommingGroupCalls] = useState([]);
  const [therapistMeetingStats, setTherapistMeetingStats] = useState<any>();
  const [sortAlphabetically, setSortAlphabetically] = useState("");
  const [therapistScore, setTherapistScore] = useState("");
  const isNewDashboard = user && (user.isNewDashboard ?? true);

  // Therapist Post-Session Form states
  const [showTherapistModal, setShowTherapistModal] = useState(false);
  const [isSubmittingTherapistModal, setIsSubmittingTherapistModal] = useState(false);
  const [therapistModalSubmitted, setTherapistModalSubmitted] = useState(false);
  const [meetingInfo, setMeetingInfo] = useState<any>(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [clientInfo, setClientInfo] = useState<any>(null);
  const [therapistInfo, setTherapistInfo] = useState<any>(null);
  const [currentSessionId, setCurrentSessionId] = useState<string>("");
  const FIXED_SESSION_ID = "1_MX40NzgxOTU0MX5-MTc1MzExMjA1ODA0OX5KVXdBRzl5bHpZS3M4ZFB4M2V1dTcwb0V-fn4";
  const [showSchedulingModal, setShowSchedulingModal] = useState(false);
  const [showDischargeConfirmation, setShowDischargeConfirmation] = useState(false);
  
  // Rejoin session states
  const [canRejoinSession, setCanRejoinSession] = useState(false);
  const [sessionRoomName, setSessionRoomName] = useState<string>("");
  const [sessionExpiresAt, setSessionExpiresAt] = useState<string>("");

  // Form state
  const [formData, setFormData] = useState({
    serviceProvided: "",
    suicidalIdeation: "No",
    homicidalIdeation: "No",
    perceptualDisturbance: "No",
    nextSessionScheduled: "No",
    higherLevelOfCareRecommended: "No",
    clinicalDirectorReviewRequired: "No",
    comments: "",
    noFollowUpReason: ""
  });

  // State for diagnosis codes
  const [diagnosisCodes, setDiagnosisCodes] = useState([]);
  const [formErrors, setFormErrors] = useState({
    serviceProvided: false,
    diagnosisCodes: false
  });

  const Limit = 3;
  let updatedSkip = 3;

  useEffect(() => {
    CommonService.getEthinicityList().then(res => {
      setEthnicityList(res.data);
    });

    loadData();
    checkPinNumber();
    checkMissingPostSessionForm();
  }, []);

  const toggle = (tab: string) => {
    setTabNo(tab);
  };
  const toggleFilterCanvas = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  const changeGender = useCallback(
    (gender: string) => () => {
      setGender(gender);
    },
    []
  );
  const checkMissingPostSessionForm = async () => {
    try {
      const response = await TherapistService.getMissingPostSessionForms();
      
      if (response.success && response.data && response.data.meetingId) {
        // Found missing form - show popup with this meetingId
        setCurrentSessionId(response.data.meetingId);
        
        // Check if we can rejoin the session
        const { roomName, isStillValid } = response.data;
        if (roomName) {
          setCanRejoinSession(isStillValid); // Always show button when roomName exists
          setSessionRoomName(roomName);
          setSessionExpiresAt("");
        } else {
          setCanRejoinSession(false);
          setSessionRoomName("");
          setSessionExpiresAt("");
        }
        
        await getMeetingInfo(response.data.meetingId);
      } else {
        // No missing forms found - don't show popup
        setCanRejoinSession(false);
        setSessionRoomName("");
        setSessionExpiresAt("");
      }
    } catch (error: any) {
      // API error - don't show popup
      setCanRejoinSession(false);
      setSessionRoomName("");
      setSessionExpiresAt("");
    }
  };

  const handleRejoinSession = () => {
    if (canRejoinSession && sessionRoomName) {
      // Close the post-session modal
      setShowTherapistModal(false);
      // Redirect to the video room using history.push for proper routing
      history.push(`/video-room/${sessionRoomName}`);
    }
  };

  const getUserDetails = async (userId: string) => {
    try {
      const url = Util.apiAuthUrl(`viewProfileByUserId/${userId}`);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const getMeetingInfo = async (sessionId: string) => {
    try {
      const url = Util.apiAuthUrl(`vonage/getMeetingByMeetingId/${sessionId}`);
      const response = await axios.get(url);

      if (response.data) {
        setMeetingInfo(response.data);

        // Fetch client and therapist details
        if (response.data.clientId) {
          const clientDetails = await getUserDetails(response.data.clientId);
          setClientInfo(clientDetails);
        }
        
        if (response.data.therapistId) {
          const therapistDetails = await getUserDetails(response.data.therapistId);
          setTherapistInfo(therapistDetails);
        }

        setShowTherapistModal(true);
      } else {
        setShowTherapistModal(true);
      }
    } catch (error: any) {
      setShowTherapistModal(true);
    }
  };

  const checkPinNumber = () => {
    if (user?.role == "THERAPIST" && !user?.pinNumber) {
      setIsOpenPinNumberModal(true);
    }
  };

  const loadData = async () => {
    const data = {
      filterValue: "YEAR",
    };

    await TherapistService.getDashboardStats(data).then(res => {
      console.log(res.data);

      setMatchedClients(res.data?.matchedClientStats);
      setupcomingAppointments(res.data?.upcommingAppointmentStats);
      setTherapistAppointmentStats(res.data?.therapistAppointmentStats);
      setAllTreatmentSessionStats(res.data?.allTreatmentSessionStats);
      setTherapistEarningsStats(res.data?.therapistEarningsStats);
      setTherapistTotalEarningsStats(res.data?.therapistTotalEarningsStats);
      setNewAppointments(res.data?.pendingAppointmentStats);
      setUpCommingGroupCalls(res?.data?.allUpCommingGroupCalls);
      setTherapistMeetingStats(res?.data?.therapistMeetingStats);
      setIsLoading(false);
      setTherapistScore(res.data?.therapistScore?.score);
    });
  };

  const handleNext = () => {
    updatedSkip = skip + 1;
    const data = {
      gender: gender,
      ethnicity: selectedEthnicity,
      searchClientName: selectedName,
      sortAlphabetically: sortAlphabetically
    };

    ClientService.getRequestsByTherapist(data, 3, updatedSkip).then(res => {
      setMatchedClients(res.data);
      setSkip(updatedSkip);
    });
  };

  const handleBack = () => {
    updatedSkip = skip - 1;
    const data = {
      gender: gender,
      ethnicity: selectedEthnicity,
      searchClientName: selectedName,
      sortAlphabetically: sortAlphabetically
    };

    ClientService.getRequestsByTherapist(data, 3, updatedSkip).then(res => {
      setMatchedClients(res.data);
      setSkip(updatedSkip);
    });
  };

  const applyFilters = () => {
    updatedSkip = 1;
    const data2 = {
      gender: gender,
      ethnicity: selectedEthnicity,
      searchClientName: selectedName,
      sortAlphabetically: sortAlphabetically
    };

    ClientService.getRequestsByTherapist(data2, 3, updatedSkip).then(res => {
      setMatchedClients(res.data);
      setSkip(1);
      toggleFilterCanvas();
    });
  };

  const refreshCurruntPage = () => {
    const data = {
      gender: gender,
      ethnicity: selectedEthnicity,
      searchClientName: selectedName,
      sortAlphabetically: sortAlphabetically
    };

    ClientService.getRequestsByTherapist(data, 3, skip).then(res => {
      if (res && res.success) {
        setMatchedClients(res.data);
        toast.success(`Client removed from your friend list!`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
        });
      }
    });
  };

  const removeFriend = (request: FriendRequest) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure want to stop seeing this client? (Please note this will remove all your scheduled appointments with this client.) Do you want to proceed?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#50a5f1",
      cancelButtonText: "Later",
      cancelButtonColor: "#f46a6a",
    }).then(result => {
      if (result.isConfirmed) {
        TherapistService.unfriendClient(request._id).then(res => {

          if (res && res.success) {
            refreshCurruntPage();
            const notificationData: NotificationModel = {
              senderId: user?._id,
              receiverId: request?.clientId?._id,
              event: NotificationEvent.REQUEST_REMOVED,
              link: "/dashboard",
              content: "You have removed from friend list By " + user?.firstname + " " + user?.lastname,
              variant: NotificationVarient.WARNING,
            };

            NotificationService.sendNotification(notificationData).then((res: any) => {
              const socketData: sendNotificationSocketData = {
                socketId: res.data.socketId,
                notifyData: notificationData,
                receiverId: request?.clientId?._id,
                senderId: user?._id,
              };

              socket.emit("send-notification", socketData);
            });
          } else {
            toast.error(`Something went wrong!`, {
              position: toast.POSITION.TOP_RIGHT,
              className: "foo-bar",
            });
          }
        });

      }
    });
  };

  const updatePinNumber = () => {
    const data = {
      pinNumber: pinNumber,
    };

    if (pinNumber?.length == 4) {
      TherapistService.createPinNumber(data).then(res => {
        if (res.success) {
          setUser(res.data);
          setPinNumber("");
          setIsOpenPinNumberModal(false);
          toast.success(`Pin number successfully created.`, {
            position: toast.POSITION.TOP_RIGHT,
            className: "foo-bar",
          });
        } else {
          toast.error(res?.error, {
            position: toast.POSITION.TOP_RIGHT,
            className: "foo-bar",
          });
        }
      });
    } else {
      toast.error(`Invalid Pin Number.`, {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
    }
  };

  function updateDiagnosisData(isUpdate: boolean) {
    if (isUpdate == true) {
      loadData();
    }
  }

  // Direct handlers for radio buttons
  const handleRadioChange = (fieldName: string, value: string) => {
    const newFormData = {
      ...formData,
      [fieldName]: value
    };

    // Clear noFollowUpReason if changing from NoFollowUp to another option
    if (fieldName === 'nextSessionScheduled' && value !== 'NoFollowUp') {
      newFormData.noFollowUpReason = '';
    }

    // Clear comments if no high-risk fields are selected as "Yes"
    const willBeEnabled = newFormData.suicidalIdeation === "Yes" ||
                         newFormData.homicidalIdeation === "Yes" ||
                         newFormData.perceptualDisturbance === "Yes" ||
                         newFormData.higherLevelOfCareRecommended === "Yes" ||
                         newFormData.clinicalDirectorReviewRequired === "Yes";

    if (!willBeEnabled) {
      newFormData.comments = "";
    }

    setFormData(newFormData);
  };

  // Check if any high-risk field is selected as "Yes" to enable comments textbox
  const isCommentsEnabled = () => {
    return formData.suicidalIdeation === "Yes" ||
           formData.homicidalIdeation === "Yes" ||
           formData.perceptualDisturbance === "Yes" ||
           formData.higherLevelOfCareRecommended === "Yes" ||
           formData.clinicalDirectorReviewRequired === "Yes";
  };

  // Handler for diagnosis code changes
  const handleDiagnosisCodeChange = (selectedOptions: any) => {
    setDiagnosisCodes(selectedOptions || []);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    let isValid = true;
    let errors = { ...formErrors };

    // Check if service is selected
    if (!formData.serviceProvided) {
      errors.serviceProvided = true;
      isValid = false;
    }

    errors.diagnosisCodes = false;
    setFormErrors(errors);
    return isValid;
  };

  const handleTherapistModalSubmit = async () => {
    // Validate form before submitting
    if (!validateForm()) {
      toast.error("Please select a service before submitting", {
        position: toast.POSITION.TOP_RIGHT,
        className: "foo-bar",
      });
      return;
    }

    // Validate NoFollowUp reason if selected
    if (formData.nextSessionScheduled === 'NoFollowUp') {
      if (!formData.noFollowUpReason) {
        toast.error("Please select a reason why a follow-up wasn't scheduled", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
        return;
      }

      // Show discharge confirmation modal
      if (formData.noFollowUpReason === 'discharge') {
        setShowDischargeConfirmation(true);
        return;
      }
    }

    setIsSubmittingTherapistModal(true);
    try {
      // Add sessionId to formData for submission
      const postData: any = {
        ...formData,
        diagnosisCodes: diagnosisCodes.map((code: any) => code.value), // Add selected diagnosis codes
        meetingId: currentSessionId, // Add meetingId to identify the call
        therapistId: user?._id, // Add therapist ID
      };

      // Add noFollowUp object if NoFollowUp is selected
      if (formData.nextSessionScheduled === 'NoFollowUp') {
        postData.noFollowUp = {
          noFollowUpReason: formData.noFollowUpReason
        };
        // Remove the flat fields
        delete postData.noFollowUpReason;
      }

      console.log("Submitting form data:", postData);

      // Check if nextSessionScheduled is "No" - handle on FE without API call
      if (formData.nextSessionScheduled === "No") {
        setShowSchedulingModal(true);
        return;
      }

      // Check if noFollowUpReason is clientPause or therapistUnavailable - handle similar to "Yes" (check for 30003)
      const shouldCheckForScheduling = formData.nextSessionScheduled === "NoFollowUp" && 
        (formData.noFollowUpReason === "clientPause" || formData.noFollowUpReason === "therapistUnavailable");

      // Call API using TherapistService
      const result = await TherapistService.submitPostSessionForm(postData);

      // Check if response contains code 30004 (transitioning form required)
      if ((result as any).code === 30004) {
        setIsSubmittingTherapistModal(false); // Reset submit button state
        toast.error((result as any).message || "You must submit the transitioning form before proceeding. Please complete the form and try again.", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
        return;
      }

      // Check if response contains code 30003 (even when success is true)
      // For clientPause and therapistUnavailable, always check for 30003 like "Yes" option
      if ((result as any).code === 30003 || (shouldCheckForScheduling && (result as any).code === 30003)) {
        setShowSchedulingModal(true);
        return;
      }

      if (result.success) {
        setIsSubmittingTherapistModal(false);
        setTherapistModalSubmitted(true);

        toast.success(`Post-Session Form submitted successfully!`, {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });

        // Close modal after 3 seconds
        setTimeout(() => {
          setShowTherapistModal(false);
        }, 3000);
      } else {
        throw new Error((result as any).message || "Failed to submit form");
      }
    } catch (error: any) {
      console.log(error);
      setIsSubmittingTherapistModal(false);

      // Check if error response contains code 30003
      // For clientPause and therapistUnavailable, always check for 30003 like "Yes" option
      const shouldCheckForScheduling = formData.nextSessionScheduled === "NoFollowUp" && 
        (formData.noFollowUpReason === "clientPause" || formData.noFollowUpReason === "therapistUnavailable");
      
      if (error.response?.data?.code === 30003 || (shouldCheckForScheduling && error.response?.data?.code === 30003)) {
        setShowSchedulingModal(true);
        return;
      }

      if (error.message === "jwt expired") {
        toast.error("jwt expired - You need to log in again", {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });

        // Redirect to login page after a few seconds
        setTimeout(() => {
          window.location.href = "https://mylavni.com/signin/";
        }, 3000);
      } else {
        toast.error(`Error submitting data: ${error.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
      }
    }
  };

  // Function to handle scheduling completion
  const handleSchedulingCompleted = () => {
    setShowSchedulingModal(false);
    setIsSubmittingTherapistModal(false); // Reset submit button state
    
    // Auto-change "No" to "Yes" when calendar closes
    if (formData.nextSessionScheduled === 'No') {
      setFormData(prev => ({
        ...prev,
        nextSessionScheduled: 'Yes'
      }));
    }
    
    // Just close the scheduling popup, user can continue with Post-Session Form
  };

  // Function to handle discharge confirmation
  const handleDischargeConfirmation = async (confirmed: boolean) => {
    setShowDischargeConfirmation(false);
    
    if (confirmed) {
      // Proceed with form submission for discharge
      setIsSubmittingTherapistModal(true);
      try {
        const postData: any = {
          ...formData,
          diagnosisCodes: diagnosisCodes.map((code: any) => code.value),
          meetingId: currentSessionId,
          therapistId: user?._id,
        };

        // Add noFollowUp object if NoFollowUp is selected
        if (formData.nextSessionScheduled === 'NoFollowUp') {
          postData.noFollowUp = {
            noFollowUpReason: formData.noFollowUpReason
          };
          // Remove the flat fields
          delete postData.noFollowUpReason;
        }

        const result = await TherapistService.submitPostSessionForm(postData);

        if (result.success) {
          setIsSubmittingTherapistModal(false);
          setTherapistModalSubmitted(true);

          toast.success("Client has been discharged successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            className: "foo-bar",
          });

          // Close modal after 3 seconds
          setTimeout(() => {
            setShowTherapistModal(false);
          }, 3000);
        } else {
          throw new Error((result as any).message || "Failed to submit form");
        }
      } catch (error: any) {
        console.log(error);
        setIsSubmittingTherapistModal(false);
        
        toast.error(`Error submitting discharge: ${error.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          className: "foo-bar",
        });
      }
    }
    // If cancelled, just close confirmation modal
  };


  return (
    <React.Fragment>
      <div className="page-content m-bg-color-white">
        <div>
          <Row>
            <Col xl="4">
              <Row>
                <div className="overflow-hidden">
                  <WelcomeCompNew
                    therapistAppointmentStats={therapistAppointmentStats}
                    clientStats={0}
                    therapistTotalEarningsStats={therapistTotalEarningsStats}
                    therapistEarningsStats={therapistEarningsStats}
                    isLoading={isLoading}
                    therapistMeetingStats={therapistMeetingStats}
                  />
                  {newAppointments?.length > 0 && !isLoading && <NewAppointmentsNew newAppointments={newAppointments} isLoading={isLoading} />}
                  {/* {upcomingAppointments?.length > 0 && !isLoading && <UpcomingAppointmentsNew upcomingAppointments={upcomingAppointments} isLoading={isLoading} />} */}
                </div>
              </Row>
              {(isNewDashboard === false) && (
                <Row>
                  <div className="overflow-hidden">
                    {upcomingAppointments?.length > 0 && !isLoading && <UpcomingAppointmentsNew upcomingAppointments={upcomingAppointments} isLoading={isLoading} />}
                  </div>
                </Row>
              )}
              {(isNewDashboard === false) && (
                <Row>
                  <div className="overflow-hidden">
                    {upCommingGroupCalls != undefined && upCommingGroupCalls.length > 0 && <UpComingGroupCall upcomingGroupCalls={upCommingGroupCalls} isLoading={isLoading} />}
                  </div>
                </Row>
              )}
              {(isNewDashboard === false) && (
                <Row>
                  <div className="overflow-hidden">
                    <ShowTherapistScore score={therapistScore} isLoading={isLoading} />
                  </div>
                </Row>
              )}
            </Col>
            {isNewDashboard === undefined || isNewDashboard === true ? (
              <Col xl="4">
                <Row>
                  <div className="overflow-hidden">
                    {upcomingAppointments?.length > 0 && !isLoading && (
                      <UpcomingAppointmentsNew upcomingAppointments={upcomingAppointments} isLoading={isLoading} />
                    )}
                  </div>
                </Row>
                <Row>
                  <div className="overflow-hidden">
                    {upCommingGroupCalls != undefined && upCommingGroupCalls.length > 0 && <UpComingGroupCall upcomingGroupCalls={upCommingGroupCalls} isLoading={isLoading} />}
                  </div>
                </Row>
                <Row>
                  <div className="overflow-hidden">
                    <ShowOngoingCalls />
                  </div>
                </Row>
              </Col>
            ) : null}

            {isNewDashboard === undefined || isNewDashboard === true ? (
              <Col xl="4">
                <Row>
                  <div className="overflow-hidden">
                    <ShowTherapistScore score={therapistScore} isLoading={isLoading} />
                  </div>
                </Row>
              </Col>
            ) : null}

            {(isNewDashboard === false) && (
              <Col xl="8">
                <Row>
                  <Col xl="6" className="d-flex justify-content-center">
                    <Card className="w-100">
                      <CardBody className="m-p-zero">
                        <div className="d-flex justify-content-between">
                          <div className="flex">
                            <span className="rounded-icon-bg-n d-flex justify-content-center align-items-center">
                              <img className="icon-h-20" src={DiscoverRequestIcon} />
                            </span>
                            <h5 className="mb-0 d-flex justify-content-center align-items-center ms-3 fc-black">
                              Client Request
                            </h5>
                          </div>
                          <div className="d-flex justify-content-end">
                            <button
                              className="btn btn-primary personalized-btn-dashboard btn-sm"
                              onClick={toggleFilterCanvas}
                            >
                              <i className="fa fa-filter"></i>
                            </button>
                          </div>
                        </div>
                        <Row>
                          <Col sm="12">
                            <ClientRequests
                              matchedClients={matchedClients}
                              setMatchedClients={setMatchedClients}
                              removeFriend={removeFriend}
                              onNext={handleNext}
                              onBack={handleBack}
                              offset={skip}
                              isLoading={isLoading}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="6" className="d-flex justify-content-center">
                    <CompletedSessions
                      allTreatmentSessionStats={allTreatmentSessionStats}
                      updateDiagnosisNote={updateDiagnosisData}
                      isLoading={isLoading}
                    />
                  </Col>
                </Row>
                <TherapistQuickChat />
                <Row>
                  <Col xl="6" className="d-flex justify-content-center">
                    <ShowOngoingCalls />
                  </Col>
                  <Col></Col>
                </Row>
              </Col>
            )}
          </Row>
        </div>
      </div>
      <Offcanvas isOpen={isFilterOpen} direction="end" toggle={toggleFilterCanvas} className="discover-canvas">
        <OffcanvasHeader toggle={toggleFilterCanvas}>Organize Clients</OffcanvasHeader>

        <OffcanvasBody>
          <div className="row  pt20 pl10">
            <div className="filter-option">
              <div className="mb-3">Name:</div>

              <div className="col-xl-12 mb-3">
                <input
                  className="form-control"
                  placeholder="Enter First Name or Last Name..."
                  onChange={e => setSelectedName(e.target.value)}
                  value={selectedName}
                />
              </div>
            </div>

            <div className="filter-option">
              <div className="mb-3">Gender:</div>

              <div className="mb-3">
                <div className="flex-wrap">
                  <ButtonGroup className="flex-wrap flex">
                    <Button color="primary" defaultChecked defaultValue={""} outline onClick={changeGender("")} active={gender === ""}>All</Button>
                    <Button color="primary" outline onClick={changeGender("Male")} active={gender === "Male"}>Male</Button>
                    <Button color="primary" outline onClick={changeGender("Female")} active={gender === "Female"}>Female</Button>
                    <Button color="primary" outline onClick={changeGender("NonBinary")} active={gender === "NonBinary"}>Non Binary</Button>
                    <Button color="primary" outline onClick={changeGender("Other")} active={gender === "Other"}>Other</Button>
                  </ButtonGroup>
                </div>
              </div>
            </div>

            <div className="filter-option">
              <div className="mb-3">Ethnicity:</div>

              <div className="col-xl-12 mb-3">
                <select className="form-control" onChange={e => setSelectedEthnicity(e.target.value)} value={selectedEthnicity}>
                  <option value="">Select Ethnicity</option>
                  {ethnicityList &&
                    ethnicityList.map(opt => (
                      <option value={opt._id} key={opt._id}>
                        {opt.ethnicity}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="filter-option">
              <div className="mb-3">Select Sorting Option:</div>

              <div className="col-xl-12 mb-3">
                <select
                  className="form-control"
                  onChange={e => setSortAlphabetically(e.target.value)}
                  value={sortAlphabetically}
                >
                  <option value="">Select an option</option>
                  <option value="alphabetically">Alphabetical Order</option>
                </select>
              </div>
            </div>

            <div className="filter-option text-center">
              <br />

              <button type="button" className="btn btn-primary mb-3 pt-2 pb-2 profile_watch_buttons" onClick={applyFilters}>
                Apply
              </button>
            </div>
          </div>
        </OffcanvasBody>
      </Offcanvas>
      <Modal isOpen={isOpenPinNumberModal} centered className="modal-sm">
        <div className="modal-body" style={{ zIndex: 9998, textAlign: "center", justifyContent: "center", alignItems: "center", paddingTop: "3vh" }}>
          <div className="call-title" style={{ paddingBottom: "2vh" }}>
            <h5>Create Pin Number</h5>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center mb-6">
            <OtpInput
              value={pinNumber}
              onChange={setPinNumber}
              numInputs={4}
              renderSeparator={<span className="mx-2"></span>}
              renderInput={props => <input {...props} className="input-pin-box" />}
              inputType={"number"}
            />
            {invalidOtp?.length > 0 && <p className="text-danger mb-0 mt-1">{invalidOtp}</p>}
          </div>
          <div className="call-action-btns" style={{ textAlign: "center", justifyContent: "center", alignItems: "center", paddingBottom: "2vh" }}>
            <div
              className="btn btn-info accept-btn"
              onClick={() => {
                updatePinNumber();
              }}
            >
              Create
            </div>
          </div>
        </div>
      </Modal>

      {/* Therapist Post-Session Form Modal */}
      <Modal isOpen={showTherapistModal} backdrop="static" keyboard={false} centered size="lg">
        <div className="modal-header">
          <h5 className="modal-title">
            Pending Post-Session Form for {clientInfo?.firstname || 'Client'} {clientInfo?.lastname || ''}
          </h5>
        </div>
        {canRejoinSession && (
          <div className="alert alert-info" style={{ margin: "15px", marginBottom: "0", borderRadius: "8px" }}>
            <div className="d-flex justify-content-between align-items-center">
              <span>
                <strong>Session is still active:</strong> You can return to the video call if needed.
              </span>
              <Button
                color="primary"
                size="sm"
                onClick={handleRejoinSession}
                style={{
                  backgroundColor: "#F47B20",
                  border: "none",
                  fontWeight: "500"
                }}
              >
                🔗 Take Me Back to Session
              </Button>
            </div>
          </div>
        )}
        <div className="modal-body">
          <Form>
            <FormGroup>
              <Label for="serviceProvided">Service Provided</Label>
              <Input
                type="select"
                name="serviceProvided"
                id="serviceProvided"
                value={formData.serviceProvided}
                onChange={handleInputChange}
                invalid={formErrors.serviceProvided}
              >
                <option value="">Select a service</option>
                <option value="Non-Billable">Non-Billable</option>
                <option value="90791">90791 - CCA</option>
                <option value="90837">90837 - Individual Therapy 53min+</option>
                <option value="90834">90834 - Individual Therapy 45min</option>
                <option value="90832">90832 - Individual Therapy 30min</option>
                <option value="90847">90847 - Couples Therapy WITH Client Present</option>
                <option value="90847">90847 - Family Therapy WITH Client Present</option>
                <option value="90846">90846 - Couples Therapy WITHOUT Client Present (Partner Alone)</option>
                <option value="90846">90846 - Family Therapy WITHOUT Client Present</option>
                <option value="90853">90853 - Group Therapy</option>
              </Input>
              {formErrors.serviceProvided && <div className="text-danger mt-1">Service selection is required</div>}
            </FormGroup>

            <div style={{ backgroundColor: "#f9f9f9", padding: "20px", marginBottom: "15px", borderRadius: "5px" }}>
              <FormGroup tag="fieldset">
                <Label>High Risk — Suicide</Label>
                <div style={{ display: "flex", gap: "30px" }}>
                  <div
                    onClick={() => handleRadioChange('suicidalIdeation', 'Yes')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.suicidalIdeation === 'Yes' ? '1px solid blue' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.suicidalIdeation === 'Yes' ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.suicidalIdeation === 'Yes' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: 'blue'
                        }} />
                      )}
                    </div>
                    Yes
                  </div>

                  <div
                    onClick={() => handleRadioChange('suicidalIdeation', 'No')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.suicidalIdeation === 'No' ? '1px solid #F47B20' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.suicidalIdeation === 'No' ? '#fff7e6' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.suicidalIdeation === 'No' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#F47B20'
                        }} />
                      )}
                    </div>
                    No
                  </div>
                </div>
              </FormGroup>
            </div>

            <div style={{ backgroundColor: "#f9f9f9", padding: "20px", marginBottom: "15px", borderRadius: "5px" }}>
              <FormGroup tag="fieldset">
                <Label>High Risk — Homicide</Label>
                <div style={{ display: "flex", gap: "30px" }}>
                  <div
                    onClick={() => handleRadioChange('homicidalIdeation', 'Yes')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.homicidalIdeation === 'Yes' ? '1px solid blue' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.homicidalIdeation === 'Yes' ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.homicidalIdeation === 'Yes' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: 'blue'
                        }} />
                      )}
                    </div>
                    Yes
                  </div>

                  <div
                    onClick={() => handleRadioChange('homicidalIdeation', 'No')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.homicidalIdeation === 'No' ? '1px solid #F47B20' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.homicidalIdeation === 'No' ? '#fff7e6' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.homicidalIdeation === 'No' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#F47B20'
                        }} />
                      )}
                    </div>
                    No
                  </div>
                </div>
              </FormGroup>
            </div>

            <div style={{ backgroundColor: "#f9f9f9", padding: "20px", marginBottom: "15px", borderRadius: "5px" }}>
              <FormGroup tag="fieldset">
                <Label>Perceptual Disturbance (Hallucinations, Paranoia, etc.)</Label>
                <div style={{ display: "flex", gap: "30px" }}>
                  <div
                    onClick={() => handleRadioChange('perceptualDisturbance', 'Yes')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.perceptualDisturbance === 'Yes' ? '1px solid blue' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.perceptualDisturbance === 'Yes' ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.perceptualDisturbance === 'Yes' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: 'blue'
                        }} />
                      )}
                    </div>
                    Yes
                  </div>

                  <div
                    onClick={() => handleRadioChange('perceptualDisturbance', 'No')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.perceptualDisturbance === 'No' ? '1px solid #F47B20' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.perceptualDisturbance === 'No' ? '#fff7e6' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.perceptualDisturbance === 'No' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#F47B20'
                        }} />
                      )}
                    </div>
                    No
                  </div>
                </div>
              </FormGroup>
            </div>

            <div style={{ backgroundColor: "#f9f9f9", padding: "20px", marginBottom: "15px", borderRadius: "5px" }}>
              <FormGroup tag="fieldset">
                <Label>Next Session Scheduled</Label>
                <div style={{ display: "flex", gap: "30px", flexWrap: "wrap" }}>
                  <div
                    onClick={() => handleRadioChange('nextSessionScheduled', 'Yes')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.nextSessionScheduled === 'Yes' ? '1px solid blue' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.nextSessionScheduled === 'Yes' ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.nextSessionScheduled === 'Yes' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: 'blue'
                        }} />
                      )}
                    </div>
                    Yes
                  </div>

                  <div
                    onClick={() => handleRadioChange('nextSessionScheduled', 'No')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.nextSessionScheduled === 'No' ? '1px solid #F47B20' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.nextSessionScheduled === 'No' ? '#fff7e6' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.nextSessionScheduled === 'No' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#F47B20'
                        }} />
                      )}
                    </div>
                    No
                  </div>

                  <div
                    onClick={() => handleRadioChange('nextSessionScheduled', 'NoFollowUp')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.nextSessionScheduled === 'NoFollowUp' ? '1px solid #6c757d' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.nextSessionScheduled === 'NoFollowUp' ? '#f8f9fa' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.nextSessionScheduled === 'NoFollowUp' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#6c757d'
                        }} />
                      )}
                    </div>
                    No follow-up appointment at this time
                  </div>
                </div>
              </FormGroup>
            </div>

            {/* Show follow-up reason section when NoFollowUp is selected */}
            {formData.nextSessionScheduled === 'NoFollowUp' && (
              <div style={{ 
                backgroundColor: "#e8f4f8", 
                padding: "20px", 
                marginBottom: "15px", 
                borderRadius: "5px",
                border: "1px solid #bee5eb"
              }}>
                <FormGroup>
                  <Label style={{ fontWeight: "600", marginBottom: "15px" }}>
                    Could you let us know why a follow-up wasn't scheduled? <span style={{ color: "red" }}>*</span>
                  </Label>
                  
                  <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    {/* Client requested a pause */}
                    <div
                      onClick={() => {
                        setFormData({ ...formData, noFollowUpReason: 'clientPause' });
                        setSelectedReason('');
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        cursor: 'pointer',
                        padding: '10px',
                        border: formData.noFollowUpReason === 'clientPause' ? '1px solid #007bff' : '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: formData.noFollowUpReason === 'clientPause' ? '#e6f7ff' : 'white'
                      }}
                    >
                      <div style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        border: '2px solid #999',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '2px'
                      }}>
                        {formData.noFollowUpReason === 'clientPause' && (
                          <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff'
                          }} />
                        )}
                      </div>
                      <div>
                        <strong>Client requested a pause</strong>
                        <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "5px" }}>
                          vacation, illness, etc.
                        </div>
                      </div>
                    </div>

                    {/* Therapist temporarily unavailable */}
                    <div
                      onClick={() => {
                        setFormData({ ...formData, noFollowUpReason: 'therapistUnavailable' });
                        setSelectedReason('');
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        cursor: 'pointer',
                        padding: '10px',
                        border: formData.noFollowUpReason === 'therapistUnavailable' ? '1px solid #007bff' : '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: formData.noFollowUpReason === 'therapistUnavailable' ? '#e6f7ff' : 'white'
                      }}
                    >
                      <div style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        border: '2px solid #999',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '2px'
                      }}>
                        {formData.noFollowUpReason === 'therapistUnavailable' && (
                          <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff'
                          }} />
                        )}
                      </div>
                      <div>
                        <strong>Therapist temporarily unavailable</strong>
                        <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "5px" }}>
                          upcoming leave, scheduling conflict
                        </div>
                      </div>
                    </div>

                    {/* Transitioning client */}
                    <div
                      onClick={() => {
                        setFormData({ ...formData, noFollowUpReason: 'transitioning' });
                        setSelectedReason('');
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        cursor: 'pointer',
                        padding: '10px',
                        border: formData.noFollowUpReason === 'transitioning' ? '1px solid #007bff' : '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: formData.noFollowUpReason === 'transitioning' ? '#e6f7ff' : 'white'
                      }}
                    >
                      <div style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        border: '2px solid #999',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '2px'
                      }}>
                        {formData.noFollowUpReason === 'transitioning' && (
                          <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff'
                          }} />
                        )}
                      </div>
                      <div>
                        <strong>Transitioning client to another therapist</strong>
                        <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "5px" }}>
                          higher level of care, repeated no-shows, better fit
                        </div>
                      </div>
                    </div>

                    {/* Client has met goals */}
                    <div
                      onClick={() => {
                        setFormData({ ...formData, noFollowUpReason: 'discharge' });
                        setSelectedReason('');
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        cursor: 'pointer',
                        padding: '10px',
                        border: formData.noFollowUpReason === 'discharge' ? '1px solid #007bff' : '1px solid #dee2e6',
                        borderRadius: '4px',
                        backgroundColor: formData.noFollowUpReason === 'discharge' ? '#e6f7ff' : 'white'
                      }}
                    >
                      <div style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        border: '2px solid #999',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: '10px',
                        marginTop: '2px'
                      }}>
                        {formData.noFollowUpReason === 'discharge' && (
                          <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff'
                          }} />
                        )}
                      </div>
                      <div>
                        <strong>Client has met goals and is being discharged</strong>
                        <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "5px" }}>
                          services terminated
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Transition form button */}
                  {formData.noFollowUpReason === 'transitioning' && (
                    <div style={{ 
                      backgroundColor: "#f8f9fa", 
                      padding: "15px", 
                      borderRadius: "8px",
                      marginTop: "15px",
                      border: "1px solid #dee2e6"
                    }}>
                      <p style={{ marginBottom: "10px", fontWeight: "500" }}>
                        Please complete the Client Transition Form to proceed.
                      </p>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={async () => {
                                          
                          // Build URL parameters
                          const params = new URLSearchParams({
                            meeting_id: currentSessionId,
                          });
                          
                          // Add current date
                          const currentDate = new Date();
                          const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                          const currentDay = String(currentDate.getDate()).padStart(2, '0');
                          const currentYear = currentDate.getFullYear();
                          params.append('date[month]', currentMonth);
                          params.append('date[day]', currentDay);
                          params.append('date[year]', currentYear.toString());
                          
                          // Add client information if available
                          if (clientInfo) {
                            if (clientInfo.firstname) {
                              params.append('clientName', `${clientInfo.firstname} ${clientInfo.lastname || ''}`.trim());
                            }
                            if (clientInfo.dateOfBirth) {
                              const birthDate = new Date(clientInfo.dateOfBirth);
                              if (!isNaN(birthDate.getTime())) {
                                const month = String(birthDate.getMonth() + 1).padStart(2, '0');
                                const day = String(birthDate.getDate()).padStart(2, '0');
                                const year = birthDate.getFullYear();
                                params.append('dob[month]', month);
                                params.append('dob[day]', day);
                                params.append('dob[year]', year.toString());
                              }
                            }
                          }
                          
                          // Add therapist information if available
                          if (therapistInfo) {
                            if (therapistInfo.firstname) {
                              params.append('nameOf', `${therapistInfo.firstname} ${therapistInfo.lastname || ''}`.trim());
                            }
                          }
                          
                          const url = `https://form.jotform.com/Lavni_info/client-transition-form?${params.toString()}`;
                          window.open(url, '_blank');
                        }}
                      >
                        Open Client Transition Form
                      </Button>
                    </div>
                  )}

                  {/* Discharge confirmation */}
                  {formData.noFollowUpReason === 'discharge' && (
                    <div style={{ 
                      backgroundColor: "#fff3cd", 
                      padding: "15px", 
                      borderRadius: "8px",
                      marginTop: "15px",
                      border: "1px solid #ffeaa7"
                    }}>
                      <p style={{ marginBottom: "0", color: "#856404", fontWeight: "500" }}>
                        ⚠️ Selecting discharge will unmatch the client from your calendar and notify administration.
                      </p>
                    </div>
                  )}
                </FormGroup>
              </div>
            )}

            <div style={{ backgroundColor: "#f9f9f9", padding: "20px", marginBottom: "15px", borderRadius: "5px" }}>
              <FormGroup tag="fieldset">
                <Label>Higher Level of Care Recommended</Label>
                <div style={{ display: "flex", gap: "30px" }}>
                  <div
                    onClick={() => handleRadioChange('higherLevelOfCareRecommended', 'Yes')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.higherLevelOfCareRecommended === 'Yes' ? '1px solid blue' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.higherLevelOfCareRecommended === 'Yes' ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.higherLevelOfCareRecommended === 'Yes' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: 'blue'
                        }} />
                      )}
                    </div>
                    Yes
                  </div>

                  <div
                    onClick={() => handleRadioChange('higherLevelOfCareRecommended', 'No')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.higherLevelOfCareRecommended === 'No' ? '1px solid #F47B20' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.higherLevelOfCareRecommended === 'No' ? '#fff7e6' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.higherLevelOfCareRecommended === 'No' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#F47B20'
                        }} />
                      )}
                    </div>
                    No
                  </div>
                </div>
              </FormGroup>
            </div>

            <div style={{ backgroundColor: "#f9f9f9", padding: "20px", marginBottom: "15px", borderRadius: "5px" }}>
              <FormGroup tag="fieldset">
                <Label>I need to meet with the Clinical Director</Label>
                <div style={{ display: "flex", gap: "30px" }}>
                  <div
                    onClick={() => handleRadioChange('clinicalDirectorReviewRequired', 'Yes')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.clinicalDirectorReviewRequired === 'Yes' ? '1px solid blue' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.clinicalDirectorReviewRequired === 'Yes' ? '#e6f7ff' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.clinicalDirectorReviewRequired === 'Yes' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: 'blue'
                        }} />
                      )}
                    </div>
                    Yes
                  </div>

                  <div
                    onClick={() => handleRadioChange('clinicalDirectorReviewRequired', 'No')}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: formData.clinicalDirectorReviewRequired === 'No' ? '1px solid #F47B20' : '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: formData.clinicalDirectorReviewRequired === 'No' ? '#fff7e6' : 'transparent'
                    }}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: '2px solid #999',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px'
                    }}>
                      {formData.clinicalDirectorReviewRequired === 'No' && (
                        <div style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          backgroundColor: '#F47B20'
                        }} />
                      )}
                    </div>
                    No
                  </div>
                </div>
              </FormGroup>
            </div>

            <FormGroup>
              <Label for="comments">Please provide details for any 'YES' responses:</Label>
              <Input
                type="textarea"
                name="comments"
                id="comments"
                value={formData.comments}
                onChange={handleInputChange}
                rows="5"
                disabled={!isCommentsEnabled()}
                style={{
                  backgroundColor: !isCommentsEnabled() ? '#f8f9fa' : 'white',
                  cursor: !isCommentsEnabled() ? 'not-allowed' : 'text'
                }}
              />
            </FormGroup>
          </Form>
        </div>
        <div className="modal-footer">
          <Button
            color="primary"
            block
            onClick={handleTherapistModalSubmit}
            disabled={isSubmittingTherapistModal || therapistModalSubmitted}
            style={{
              backgroundColor: "#F47B20",
              border: "none",
              borderRadius: "4px",
              padding: "10px 15px"
            }}
          >
            {isSubmittingTherapistModal ? 'Submitting...' : therapistModalSubmitted ? 'Submitted' : 'Submit Form'}
          </Button>
        </div>
      </Modal>

      {/* Use the separated SchedulingCalendar component */}
      <SchedulingCalendar 
        isOpen={showSchedulingModal} 
        onClose={handleSchedulingCompleted} 
        meetingInfo={meetingInfo}
        noFollowUpReason={formData.noFollowUpReason}
        isTentativeAppointment={
          formData.nextSessionScheduled === 'NoFollowUp' && 
          (formData.noFollowUpReason === 'clientPause' || formData.noFollowUpReason === 'therapistUnavailable')
        }
      />

      {/* Discharge Confirmation Modal */}
      <Modal isOpen={showDischargeConfirmation} backdrop="static" keyboard={false} centered size="sm">
        <div className="modal-header">
          <h5 className="modal-title">Confirm Discharge</h5>
        </div>
        <div className="modal-body">
          <p style={{ textAlign: "center", marginBottom: "20px" }}>
            Are you sure you want to discharge this client?
          </p>
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            onClick={() => handleDischargeConfirmation(false)}
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => handleDischargeConfirmation(true)}
            style={{
              backgroundColor: "#F47B20",
              border: "none"
            }}
          >
            Yes, Discharge
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default TherapistDashboardNew;
